import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Button,
  Typography,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  TextField,
  Popover,
  Grid,
  Menu,
  Divider,
  MenuItem,
  Collapse,
  Chip,
  alpha, // ✅✅✅ FIX: alpha import add kiya (dark mode helper)
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import PrintIcon from "@mui/icons-material/Print";
import { useNavigate, useLocation  } from "react-router-dom";
import { getIssues, deleteIssue } from "../../../Services/Services";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InfiniteScroll from "react-infinite-scroll-component";
import { handlePrintIssue } from "./IssuePrint";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useMediaQuery, useTheme } from "@mui/material";

const IssueList = () => {
  const [issues, setIssues] = useState([]);
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const [anchorEl, setAnchorEl] = useState(null);
  const [issueToDelete, setIssueToDelete] = useState(null);
  const [searchProject, setSearchProject] = useState("");
  const [searchSlipNo, setSearchSlipNo] = useState("");
  const [showCustomDateInputs, setShowCustomDateInputs] = useState(false);
  const [tempCustomDateRange, setTempCustomDateRange] = useState({ from: "", to: "" });
  const [dateMenuAnchor, setDateMenuAnchor] = useState(null);
  const [customDateRange, setCustomDateRange] = useState({
    from: "",
    to: "",
  });
  const [filters, setFilters] = useState({
    date_range: "today",
  });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [expandedIssue, setExpandedIssue] = useState(null);
  const location = useLocation();
  const isDark = theme.palette.mode === "dark";
  const tableHeadBg = isDark ? "#252b38" : "#f0f4ff";
  const zebraBg = (i) =>
    isDark
      ? i % 2 === 0
        ? "#20242e" // even row - dark (solid)
        : "#1a1d26" // odd row - dark (solid)
      : i % 2 === 0
      ? "#fafafa" // even row - light (same as before)
      : "#ffffff"; // odd row - light (same as before)
  const rowHoverBg = isDark ? "#2c3242" : "#e3f2fd";

  const getDateRangeDisplay = (rangeType) => {
    const now = new Date();
    const formatDate = (date) => {
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    switch (rangeType) {
      case "today":
        return formatDate(now);
      case "yesterday":
        const yesterday = new Date(now);
        yesterday.setDate(yesterday.getDate() - 1);
        return formatDate(yesterday);
      case "this_week":
        const weekStart = new Date(now);
        weekStart.setDate(weekStart.getDate() - weekStart.getDay() + 1);
        return `${formatDate(weekStart)} to ${formatDate(now)}`;
      case "previous_week":
        const prevWeekEnd = new Date(now);
        prevWeekEnd.setDate(prevWeekEnd.getDate() - prevWeekEnd.getDay());
        const prevWeekStart = new Date(prevWeekEnd);
        prevWeekStart.setDate(prevWeekStart.getDate() - 6);
        return `${formatDate(prevWeekStart)} to ${formatDate(prevWeekEnd)}`;
      case "this_month":
        const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
        return `${formatDate(monthStart)} to ${formatDate(now)}`;
      case "current_year":
        const yearStart = new Date(now.getFullYear(), 0, 1);
        return `${formatDate(yearStart)} to ${formatDate(now)}`;
      case "financial_year":
        let fyStart;
        if (now.getMonth() >= 3) {
          fyStart = new Date(now.getFullYear(), 3, 1);
        } else {
          fyStart = new Date(now.getFullYear() - 1, 3, 1);
        }
        return `${formatDate(fyStart)} to ${formatDate(now)}`;
      default:
        return "";
    }
  };

  const formatDateDisplay = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  const handleReset = () => {
    setFilters({
      date_range: "today",
    });
    setSearchSlipNo("");
    setSearchProject("");
    setCustomDateRange({ from: "", to: "" });
    setTempCustomDateRange({ from: "", to: "" });
    setShowCustomDateInputs(false);
  };

  const handleApplyCustomDateRange = () => {
    if (tempCustomDateRange.from && tempCustomDateRange.to) {
      setCustomDateRange({
        from: tempCustomDateRange.from,
        to: tempCustomDateRange.to,
      });
      setFilters((prev) => ({ ...prev, date_range: "custom" }));
      setDateMenuAnchor(null);
      setShowCustomDateInputs(false);
    } else {
      toast.warning("Please select both From and To dates");
    }
  };

  const handleCancelCustomDateRange = () => {
    setTempCustomDateRange({ from: "", to: "" });
    setShowCustomDateInputs(false);
  };


 useEffect(() => {
  const handler = setTimeout(() => {
    fetchIssues(1, true, {
      project_name: searchProject,
      slip_no: searchSlipNo,
      date_range: filters.date_range || "today",
      from_date: customDateRange.from || "",
      to_date: customDateRange.to || "",
    });
  }, 500);

  return () => clearTimeout(handler);
}, [
  searchProject,
  searchSlipNo,
  filters.date_range,
  customDateRange,
  location.key,
  location.state,
]);

  const fetchIssues = async (pageNumber = 1, reset = false, filters = {}) => {
    const res = await getIssues(pageNumber, filters);
    if (reset) {
      setIssues(res.results);
    } else {
      setIssues((prev) => [...prev, ...res.results]);
    }

    setHasMore(res.next !== null);
    setPage(pageNumber);
  };

  const handleAddClick = () => {
    navigate("/dashboard/issue-form");
  };

  const handleEdit = (issue) => {
    navigate("/dashboard/issue-form", { state: { issue: issue } });
  };

 const handleDelete = async (id) => {
  if (window.confirm("Are you sure you want to delete this issue?")) {
    try {
      await deleteIssue(id);
      toast.success("Issue deleted successfully!");
      setIssues((prev) => prev.filter((i) => i.issue_id !== id));
    } catch (err) {
      toast.error("Failed to delete issue.");
      console.error(err);
    }
  }
};

 function formatOnlyDate(dateTimeString) {
  if (!dateTimeString) return "N/A";

  const datePart = dateTimeString.split("T")[0];

  const [year, month, day] = datePart.split("-");

  return `${day}-${month}-${year}`;
}

  useEffect(() => {
    document.body.style.overflow = isMobile ? 'auto' : 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMobile]);
  return (
    <Box>
      {/* ✅✅✅ FIX #2: Toast bhi theme ke saath */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        theme={isDark ? "dark" : "light"}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          width: "100%",
          mt: { xs: 2, sm: 1, md: 1 },
          pt: 0,
          mb: 1,
        }}
      >
        <Grid container spacing={2} alignItems="center">
          {/* Date Range Dropdown */}
          <Grid item xs={12} sm={2.5}>
            <TextField
              fullWidth
              label="Date Range"
              value={
                filters.date_range === "custom" &&
                  customDateRange.from &&
                  customDateRange.to
                  ? `${formatDateDisplay(customDateRange.from)} to ${formatDateDisplay(customDateRange.to)}`
                  : filters.date_range === "today"
                    ? "Today"
                    : filters.date_range === "yesterday"
                      ? "Yesterday"
                      : filters.date_range === "this_week"
                        ? "This Week"
                        : filters.date_range === "previous_week"
                          ? "Previous Week"
                          : filters.date_range === "this_month"
                            ? "This Month"
                            : filters.date_range === "current_year"
                              ? "Current Year"
                              : filters.date_range === "financial_year"
                                ? "Financial Year"
                                : "Select Date Range"
              }
              onClick={(e) => setDateMenuAnchor(e.currentTarget)}
              size="small"
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <IconButton size="small" edge="end">
                    <ArrowDropDownIcon />
                  </IconButton>
                ),
              }}
              sx={{
                cursor: "pointer",
                fontWeight: "bold",
                "& .MuiInputBase-input": {
                  fontSize: "0.8rem",
                  padding: "4px 8px",
                },
                "& .MuiInputBase-root": {
                  height: 30,
                  borderRadius: 0,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.6rem",
                },
              }}
            />
          </Grid>

          {/* Search by Slip No */}
          <Grid item xs={12} sm={3.5}>
            <TextField
              fullWidth
              label="Search by Slip No"
              variant="outlined"
              value={searchSlipNo}
              onChange={(e) => setSearchSlipNo(e.target.value)}
              size="small"
              sx={{
                "& .MuiInputBase-root": {
                  height: 30,
                  fontSize: "0.7rem",
                  borderRadius: 0,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.7rem",
                },
              }}
            />
          </Grid>

          {/* Search by Project Name */}
          <Grid item xs={12} sm={3.5}>
            <TextField
              fullWidth
              label="Search by MOS Name"
              variant="outlined"
              value={searchProject}
              onChange={(e) => setSearchProject(e.target.value)}
              size="small"
              sx={{
                "& .MuiInputBase-root": {
                  height: 30,
                  fontSize: "0.7rem",
                  borderRadius: 0,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.7rem",
                },
              }}
            />
          </Grid>

          {/* Reset Button */}
          <Grid item xs={6} sm={1.25}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              size="small"
              onClick={handleReset}
              sx={{
                height: 30,
                fontSize: "0.7rem",
                borderRadius: 0,
                whiteSpace: "nowrap",
              }}
            >
              Reset
            </Button>
          </Grid>

          {/* Issue Button */}
          <Grid item xs={6} sm={1.25}>
            <Button
              fullWidth
              variant="contained"
              size="small"
              startIcon={<AddIcon sx={{ fontSize: 18 }} />}
              onClick={handleAddClick}
              sx={{
                height: 30,
                fontSize: "0.7rem",
                borderRadius: 0,
                whiteSpace: "nowrap",
              }}
            >
              Issue
            </Button>
          </Grid>
        </Grid>
        {/* ✅✅✅ FIX #3: Date Menu — theme-aware bg/border/shadow */}
        <Menu
          anchorEl={dateMenuAnchor}
          open={Boolean(dateMenuAnchor)}
          onClose={() => {
            setDateMenuAnchor(null);
            setShowCustomDateInputs(false);
            setTempCustomDateRange({ from: "", to: "" });
          }}
          PaperProps={{
            sx: {
              width: 350,
              maxHeight: 500,
              bgcolor: "background.paper",
              backgroundImage: "none",
              border: "1px solid",
              borderColor: "divider",
              boxShadow: isDark
                ? "0 8px 28px rgba(0,0,0,0.6)"
                : "0 4px 16px rgba(0,0,0,0.14)",
              "& .MuiTypography-root": {
                fontSize: "0.65rem",
              },
            },
          }}
        >
          {[
            { key: "today", label: "Today" },
            { key: "yesterday", label: "Yesterday" },
            { key: "this_week", label: "This Week" },
            { key: "previous_week", label: "Previous Week" },
            { key: "this_month", label: "This Month" },
            { key: "current_year", label: "Current Year" },
            { key: "financial_year", label: "Financial Year" },
          ].map((range) => (
            <MenuItem
              key={range.key}
              onClick={() => {
                setFilters((prev) => ({ ...prev, date_range: range.key }));
                setCustomDateRange({ from: "", to: "" });
                setDateMenuAnchor(null);
                setShowCustomDateInputs(false);
              }}
              sx={{
                "&:hover": {
                  bgcolor: (t) =>
                    t.palette.mode === "dark"
                      ? alpha(t.palette.primary.main, 0.1)
                      : alpha(t.palette.primary.main, 0.06),
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Typography variant="body2" sx={{ color: "text.primary" }}>
                  {range.label}
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: "0.65rem" }}
                >
                  {getDateRangeDisplay(range.key)}
                </Typography>
              </Box>
            </MenuItem>
          ))}

          <Divider />

          <MenuItem
            onClick={() => setShowCustomDateInputs(!showCustomDateInputs)}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              bgcolor: showCustomDateInputs
                ? (t) =>
                    t.palette.mode === "dark"
                      ? alpha(t.palette.primary.main, 0.15)
                      : "#e3f2fd"
                : "inherit",
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontWeight: showCustomDateInputs ? 600 : 400,
                color: "text.primary",
              }}
            >
              Custom Date Range
            </Typography>
            {showCustomDateInputs ? <ExpandLess /> : <ExpandMore />}
          </MenuItem>

          <Collapse in={showCustomDateInputs} timeout="auto" unmountOnExit>
            <Box
              sx={{
                px: 2,
                py: 2,
                bgcolor: (t) =>
                  t.palette.mode === "dark"
                    ? alpha(t.palette.common.white, 0.04)
                    : "#f5f5f5",
                borderTop: "1px solid",
                borderColor: "divider",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: "block" }}>
                Select Date Range
              </Typography>

              <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                <TextField
                  label="From Date"
                  type="date"
                  size="small"
                  value={tempCustomDateRange.from}
                  onChange={(e) =>
                    setTempCustomDateRange((prev) => ({
                      ...prev,
                      from: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    max: tempCustomDateRange.to || new Date().toISOString().split("T")[0],
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": {
                      height: 40,
                      fontSize: "0.75rem",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.75rem",
                    },
                  }}
                />

                <TextField
                  label="To Date"
                  type="date"
                  size="small"
                  value={tempCustomDateRange.to}
                  onChange={(e) =>
                    setTempCustomDateRange((prev) => ({
                      ...prev,
                      to: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    min: tempCustomDateRange.from || undefined,
                    max: new Date().toISOString().split("T")[0],
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": {
                      height: 40,
                      fontSize: "0.75rem",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.75rem",
                    },
                  }}
                />
              </Box>

              {tempCustomDateRange.from && tempCustomDateRange.to && (
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    mb: 1.5,
                    p: 1,
                    bgcolor: (t) =>
                      t.palette.mode === "dark"
                        ? alpha(t.palette.success.main, 0.15)
                        : "#e8f5e9",
                    borderRadius: 1,
                    textAlign: "center",
                    color: "success.main",
                    fontWeight: 500,
                  }}
                >
                  📅 {formatDateDisplay(tempCustomDateRange.from)} to{" "}
                  {formatDateDisplay(tempCustomDateRange.to)}
                </Typography>
              )}

              <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCancelCustomDateRange}
                  sx={{
                    fontSize: "0.7rem",
                    textTransform: "none",
                    borderRadius: 1,
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleApplyCustomDateRange}
                  disabled={!tempCustomDateRange.from || !tempCustomDateRange.to}
                  sx={{
                    fontSize: "0.7rem",
                    textTransform: "none",
                    borderRadius: 1,
                  }}
                >
                  Apply
                </Button>
              </Box>
            </Box>
          </Collapse>
        </Menu>
      </Box>
      <InfiniteScroll
        dataLength={issues.length}
        next={() =>
          fetchIssues(page + 1, false, {
            project_name: searchProject,
            slip_no: searchSlipNo,
            date_range: filters.date_range || "this_month",
            from_date: customDateRange.from || "",
            to_date: customDateRange.to || "",
          })
        }
        hasMore={hasMore}
        loader={
          <Typography sx={{ textAlign: "center", p: 2, color: "text.secondary" }}>
            Loading...
          </Typography>
        }
      >
        {isMobile ? (
          /* 📱 MOBILE VIEW - Expandable Cards */
          /* ✅✅✅ FIX #4: Mobile cards — saare hardcoded colors theme-aware */
          <Box sx={{ bgcolor: "background.paper" }}>
            {issues.map((issue, index) => (
              <Box key={issue.issue_id || index}>
                <Box
                  onClick={() =>
                    setExpandedIssue(
                      expandedIssue === issue.issue_id ? null : issue.issue_id
                    )
                  }
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1.5,
                    cursor: "pointer",
                    bgcolor: zebraBg(index), // ✅ theme-aware
                    "&:active": { bgcolor: "action.selected" }, // ✅ theme-aware
                    borderLeft: "4px solid",
                    borderLeftColor: "primary.main", // ✅ theme-aware
                    transition: "background-color 0.15s ease",
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 0.5,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          color: "text.disabled", // ✅ pehle #666 hardcoded tha
                          minWidth: 25,
                        }}
                      >
                        #{index + 1}
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.85rem",
                          flex: 1,
                          color: "text.primary", // ✅ theme-aware
                        }}
                      >
                        {issue.go_no || "N/A"}
                      </Typography>
                    </Box>

                    <Typography
                      sx={{
                        fontSize: "0.75rem",
                        color: "text.secondary", // ✅ pehle #666 hardcoded tha
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <span style={{ fontWeight: 500 }}>
                        {issue.project_name?.substring(0, 20) || "N/A"}
                      </span>
                      <span>•</span>
                      <span style={{ fontSize: "0.7rem" }}>
                        {formatOnlyDate(issue.created_at)}
                      </span>
                    </Typography>
                  </Box>

                  <IconButton size="small" sx={{ ml: 1 }}>
                    {expandedIssue === issue.issue_id ? (
                      <ExpandLess fontSize="small" />
                    ) : (
                      <ExpandMore fontSize="small" />
                    )}
                  </IconButton>
                </Box>

                <Collapse
                  in={expandedIssue === issue.issue_id}
                  timeout="auto"
                  unmountOnExit
                >
                  <Box
                    sx={{
                      px: 1.5,
                      py: 1,
                      bgcolor: (t) =>
                        t.palette.mode === "dark"
                          ? alpha(t.palette.common.white, 0.05)
                          : alpha(t.palette.primary.main, 0.04), // ✅ theme-aware
                      borderLeft: "4px solid",
                      borderLeftColor: "primary.main",
                    }}
                  >
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: 0.8,
                        mb: 1,
                      }}
                    >
                      {/* Department */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "text.disabled", // ✅ pehle #999
                            letterSpacing: "0.5px",
                          }}
                        >
                          DEPARTMENT
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "text.secondary", // ✅ pehle #555
                          }}
                        >
                          {issue.labour_name || "N/A"}
                        </Typography>
                      </Box>

                      {/* Issued By */}
                      <Box sx={{ gridColumn: "1 / -1" }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "text.disabled",
                            letterSpacing: "0.5px",
                          }}
                        >
                          ISSUED BY
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.75rem",
                            fontWeight: 500,
                            color: "text.primary", // ✅ pehle #333
                          }}
                        >
                          {issue.created_by_name || issue.created_by || "N/A"}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "text.disabled",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Res Slip no.
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: "0.75rem",
                            fontWeight: 500,
                            color: "text.primary",
                          }}
                        >
                          {issue.slip_no || "N/A"}
                        </Typography>
                      </Box>
                    </Box>

                    {issue.remarks && (
                      <Box sx={{ mb: 0.8 }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "text.disabled",
                            letterSpacing: "0.5px",
                            mb: 0.3,
                          }}
                        >
                          REMARKS
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            color: "text.secondary", // ✅ pehle #555
                            fontStyle: "italic",
                            lineHeight: 1.3,
                          }}
                        >
                          {issue.remarks}
                        </Typography>
                      </Box>
                    )}

                    <Divider sx={{ my: 1, borderColor: "divider" }} />

                    {/* Action Buttons — ✅ theme-aware (dark me alpha, light me same colors) */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        gap: 0.6,
                      }}
                    >
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEdit(issue);
                        }}
                        sx={{
                          bgcolor: (t) =>
                            t.palette.mode === "dark"
                              ? alpha(t.palette.primary.main, 0.15)
                              : "#e3f2fd",
                          borderRadius: "6px",
                          width: 32,
                          height: 32,
                          "&:hover": {
                            bgcolor: (t) =>
                              t.palette.mode === "dark"
                                ? alpha(t.palette.primary.main, 0.28)
                                : "#bbdefb",
                            transform: "scale(1.05)",
                          },
                          transition: "all 0.2s",
                        }}
                      >
                        <EditIcon sx={{ fontSize: "1rem", color: "primary.main" }} />
                      </IconButton>

                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          handlePrintIssue(issue);
                        }}
                        sx={{
                          bgcolor: (t) =>
                            t.palette.mode === "dark"
                              ? alpha("#7b1fa2", 0.25)
                              : "#f3e5f5",
                          borderRadius: "6px",
                          width: 32,
                          height: 32,
                          "&:hover": {
                            bgcolor: (t) =>
                              t.palette.mode === "dark"
                                ? alpha("#7b1fa2", 0.4)
                                : "#e1bee7",
                            transform: "scale(1.05)",
                          },
                          transition: "all 0.2s",
                        }}
                      >
                        <PrintIcon
                          sx={{
                            fontSize: "1rem",
                            color: isDark ? "#ce93d8" : "#7b1fa2",
                          }}
                        />
                      </IconButton>

                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          setAnchorEl(e.currentTarget);
                          setIssueToDelete(issue.issue_id);
                        }}
                        sx={{
                          bgcolor: (t) =>
                            t.palette.mode === "dark"
                              ? alpha(t.palette.error.main, 0.15)
                              : "#ffebee",
                          borderRadius: "6px",
                          width: 32,
                          height: 32,
                          "&:hover": {
                            bgcolor: (t) =>
                              t.palette.mode === "dark"
                                ? alpha(t.palette.error.main, 0.28)
                                : "#ffcdd2",
                            transform: "scale(1.05)",
                          },
                          transition: "all 0.2s",
                        }}
                      >
                        <DeleteIcon
                          sx={{ fontSize: "1rem", color: "error.main" }}
                        />
                      </IconButton>
                    </Box>
                  </Box>
                </Collapse>

                <Divider />
              </Box>
            ))}
          </Box>
        ) : (
          /* 💻 DESKTOP VIEW - Table */
          /* ✅✅✅ FIX #5: TableContainer — theme-aware bg/border/shadow */
          <TableContainer
            component={Paper}
            elevation={0}
            sx={{
              maxHeight: "88vh",
              overflow: "auto",
              overflowX: "auto",
              bgcolor: "background.paper",
              backgroundImage: "none",
              border: "1px solid",
              borderColor: "divider",
              boxShadow: isDark ? "0 4px 18px rgba(0,0,0,0.35)" : "none",
            }}
          >
            <Table
              stickyHeader
              size="small"
              sx={{
                minWidth: 1200,
                "& td, & th": {
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  borderBottom: "1px solid",
                  borderColor: "divider", // ✅ pehle #ccc hardcoded tha
                },
              }}
            >
              {/* ✅✅✅ FIX #6: TableHead — SOLID theme-aware bg.
                  ❌ Pehle: dark me "black", aur TableRow ke andar
                     #f5f5f5!important + color:#333 — isliye dark me
                     header ka text invisible / ulta dikh raha tha. */}
              <TableHead
                sx={{
                  "& th": {
                    fontWeight: "bold",
                    fontSize: "0.75rem",
                    color: "text.primary",
                    backgroundColor: tableHeadBg, // ✅ SOLID
                    borderBottom: "1px solid",
                    borderColor: "divider",
                    letterSpacing: "0.04em",
                  },
                }}
              >
                <TableRow>
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: 0,
                      backgroundColor: `${tableHeadBg} !important`, // ✅ SOLID
                      zIndex: 4,
                      padding: "0px",
                      minWidth: 50,
                    }}
                  >
                    S.No
                  </TableCell>
                  <TableCell>I.N. No</TableCell>
                  <TableCell>Req. Slip No</TableCell>
                  <TableCell>MOS</TableCell>
                  <TableCell>Issued By</TableCell>
                  <TableCell>Remark</TableCell>
                  <TableCell>Department</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell
                    align="center"
                    className="no-print"
                    sx={{
                      position: "sticky",
                      right: 0,
                      backgroundColor: `${tableHeadBg} !important`, // ✅ SOLID (pehle "#f5f5f5 !!important" typo bhi tha)
                      zIndex: 4,
                      minWidth: 80,
                      padding: "0px",
                    }}
                  >
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {issues.map((issue, index) => (
                  /* ✅✅✅ FIX #7: TableRow — "hover" prop hataya,
                     hardcoded #fafafa/#ffffff hataye, SOLID zebra + SOLID hover */
                  <TableRow
                    key={issue.issue_id || index}
                    sx={{
                      backgroundColor: zebraBg(index),
                      transition: "background-color 0.15s ease",
                      "&:hover": {
                        backgroundColor: `${rowHoverBg} !important`, // ✅ SOLID
                        "& td": { backgroundColor: "inherit !important" },
                      },
                      "& td": {
                        paddingRight: "13px !important",
                        paddingLeft: "13px !important",
                        padding: "0px",
                        fontSize: { xs: "0.65rem", sm: "0.75rem" },
                        whiteSpace: "nowrap",
                        color: "text.primary", // ✅ pehle dark me hardcoded white + black bg tha
                      },
                    }}
                  >
                    {/* Sticky S.No — ✅ "inherit" (row SOLID hai ab), pehle
                        yaha #fafafa/#ffffff hardcode tha jo dark me light dikhta tha */}
                    <TableCell
                      sx={{
                        position: "sticky",
                        left: 0,
                        zIndex: 3,
                        bgcolor: "inherit",
                        minWidth: 50,
                      }}
                    >
                      {index + 1}
                    </TableCell>
                    <TableCell>{issue.go_no}</TableCell>
                    <TableCell>{issue.slip_no}</TableCell>
                    <TableCell>{issue.project_name}</TableCell>
                    <TableCell>
                      {issue.created_by_name || issue.created_by}
                    </TableCell>
                    <TableCell>{issue.remarks}</TableCell>
                    <TableCell>{issue.labour_name}</TableCell>
                    <TableCell>{formatOnlyDate(issue.created_at)}</TableCell>

                    {/* Sticky Actions — ✅ same "inherit" treatment */}
                    <TableCell
                      align="center"
                      className="no-print"
                      sx={{
                        position: "sticky",
                        right: 0,
                        zIndex: 3,
                        bgcolor: "inherit",
                        minWidth: 80,
                      }}
                    >
                      <IconButton
                        color="primary"
                        sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                        size="small"
                        onClick={() => handleEdit(issue)}
                      >
                        <EditIcon transform="scale(0.6)" />
                      </IconButton>
                      <IconButton
                        sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                        onClick={() => handlePrintIssue(issues[index])}
                        size="small"
                        color={isDark ? "warning" : "default"}
                      >
                        <PrintIcon transform="scale(0.6)" />
                      </IconButton>
                      <IconButton
                        sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                        size="small"
                        color="error"
                        onClick={(e) => {
                           e.preventDefault();
                           e.stopPropagation();
                          setAnchorEl(e.currentTarget);
                          setIssueToDelete(issue.issue_id);
                        }}
                      >
                        <DeleteIcon transform="scale(0.6)" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </InfiniteScroll>

      {/* ✅✅✅ FIX #8: Delete Popover — theme-aware paper */}
      <Popover
  open={Boolean(anchorEl)}
  anchorEl={anchorEl}
  onClose={() => {
    setAnchorEl(null);
    setIssueToDelete(null);
  }}
  anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
  transformOrigin={{ vertical: "top", horizontal: "center" }}
  PaperProps={{
    sx: {
      bgcolor: "background.paper",
      backgroundImage: "none",
      border: "1px solid",
      borderColor: "divider",
      boxShadow: isDark
        ? "0 8px 28px rgba(0,0,0,0.6)"
        : "0 4px 16px rgba(0,0,0,0.14)",
    },
  }}
>
  <Box sx={{ p: 2, minWidth: 180 }}>
    <Typography variant="body2" sx={{ color: "text.primary" }}>
      Are you sure?
    </Typography>
    <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
      <Button
        color="error"
        variant="contained"
        size="small"
        onClick={async () => {
          if (!issueToDelete) {
            setAnchorEl(null);
            return;
          }

          const idToDelete = issueToDelete;

          setAnchorEl(null);
          setIssueToDelete(null);

          try {
            await deleteIssue(idToDelete);
            toast.success("Issue deleted successfully!");
            setIssues((prev) =>
              prev.filter((i) => i.issue_id !== idToDelete)
            );
          } catch (err) {
            toast.error("Failed to delete issue.");
            console.error(err);
          }
        }}
      >
        Yes
      </Button>
      <Button
        size="small"
        variant="outlined"
        onClick={() => {
          setAnchorEl(null);
          setIssueToDelete(null);
        }}
      >
        No
      </Button>
    </Box>
  </Box>
</Popover>
    </Box>
  );
};

export default IssueList;
